(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            },
            'staffManager': {
                method: 'GET',
                url: 'api/account/recognize_staff_manager',
                isArray: false
            }
        });

        return service;
    }
})();
